import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-vehicle-model-list-item',
  templateUrl: './vehicle-model-list-item.component.html',
  styleUrls: []
})
export class VehicleModelListItemComponent implements OnInit {

  @Input() item: any;
  @Input() paddingTop = false;
  @Input() paddingBottom = false;

  constructor() { }

  ngOnInit() {
  }

}
